export enum StatusCategory {
    ALL = 'ALL',
    LOADED = 'LOADED',
    REMAINING = 'REMAINING',
    CANCELED = 'CANCELED',
}